import { BackOffice, DOMAIN } from "consts/general";
import { getEnvironment } from "./support";

export const getBackofficePath = (type: BackOffice, ...rest: Array<string>) => {
    const env = getEnvironment();

    return [
        [env, type, DOMAIN]
            .filter(Boolean)
            .join('.'),
        ...rest
    ].join('/');
};
